// Research and Innovation page

import { useNavigate } from "react-router-dom";
import HeroSection from "../components/Common/HeroSection";
import BannerSection from "../components/Common/PlatformBannerSection";
import ResearchInnovationPillars from "../components/ResearchAndInnovation/ResearchPillar";
import ResearchFocusAreas from "../components/ResearchAndInnovation/ResearchFocusSection";
import InnovationOutcomes from "../components/ResearchAndInnovation/InnovationOutcomes";
import TopBottomImgContent from "../components/Common/TopBottomImgContent";
import HeadernDescription from "../components/Common/HeadernDescription";
import LandingHero from "../components/Common/LandingHero";
import DigitalInnovation from "../components/Home/DigitalInnovation";
import data from "../content.json";
import ProcessSection from "../components/ResearchAndInnovation/ProcessSection";
import { Link } from "react-router-dom";

const ResearchAndInnovation = () => {
  const navigate = useNavigate();

  const {
    sec3HeadingPara,
    keyServices2,
    sec4HeadingPara,
    sec2HeadingPara,
    sec5HeadingPara,
  } = data.research;

  const handleScheduleDemo = () => {
    navigate("/get-in-touch?purpose=Product Demo");
  };

  return (
    <>
      {/* Hero Section */}
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.research.hero} />
      </div>
      <div className="px-3 md:px-0" id="research">
        {/*2nd Section */}
        <div className="w-full py-7 md:pb-16 md:pt-28">
          <div className="md:px-6">
            <HeadernDescription
              section={sec2HeadingPara}
              align="left"
            ></HeadernDescription>

            <DigitalInnovation
              section={keyServices2}
              columns={4}
              arrowIcon={true}
              cardHeight="25vh"
            />
          </div>
        </div>

        {/*3rd Section */}
        <InnovationOutcomes></InnovationOutcomes>

        {/*4th Section */}
        <div className="w-full py-7 lg:py-16 bg-light">
          <div className="">
            <HeadernDescription
              section={sec4HeadingPara}
              align="center"
            ></HeadernDescription>
            <ProcessSection></ProcessSection>
          </div>
        </div>

        {/*5th Section */}
        <div className="w-full py-7 lg:py-16">
          <div className="text-center">
            <HeadernDescription
              section={sec5HeadingPara}
              align="center"
            ></HeadernDescription>
            <div>
              <Link to="/digital-health">
                <button className="inline-flex btn btn-primary">
                  View Solutions
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResearchAndInnovation;
